export function formatPhoneNumber(string: string | null) {
    if (!string) return "-";
    const firstDigit = string[0]; // get the first digit
    const remainingDigits = string.slice(1); // get the remaining digits
    const splitArr = remainingDigits.match(/.{1,2}/g); // split the remaining digits into pairs of two
    if (!splitArr) return "-";
    return `+33 ${firstDigit} ${splitArr.join(" ")}`; // join the pairs with a space and add the first digit
  }
  